jQuery(document).ready(function () {
    var $carousel = jQuery('.wm-frontpageCarousel__carousel');
    var slick = jQuery($carousel).slick({
        fade: true,
        cssEase: 'linear',
        lazyload: 'ondemand',
        dots: true,
        appendArrows: jQuery('.wm-frontpageCarousel__arrows'),
        adaptiveHeight: true
    });
    jQuery('.wm-serviceCarousel').each(function () {
        jQuery(this).find('.wm-serviceCarousel__imagesCarousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: jQuery(this).find('.wm-serviceCarousel__textsCarousel'),
            infinite: false,
        });
        jQuery(this).find('.wm-serviceCarousel__textsCarousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: jQuery(this).find('.wm-serviceCarousel__imagesCarousel'),
            appendArrows: jQuery(this).find('.wm-serviceCarousel__arrows'),
            infinite: false,
            adaptiveHeight: true
        });
    });
    jQuery('.wm-imageCarousel__carousel').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        appendArrows: jQuery('.wm-imageCarousel__arrows'),
        infinite: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });
    jQuery('.wm-safetyCultureCarousel__carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: jQuery('.wm-safetyCultureCarousel__arrows'),
        infinite: false
    });
    jQuery('.wm-quoteCarousel__carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: jQuery('.wm-quoteCarousel__arrows'),
        infinite: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 3000,
    });
    jQuery('.wm-companiesCarousel__carousel').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        appendArrows: jQuery('.wm-companiesCarousel__arrows'),
        infinite: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });
});
